<template>
    <div class="otherRulePop">
        <el-dialog title="提示" :visible.sync="dialogVisible" width="600px">
            <p class="influence">客户绑定模式，每天只能修改一次，修改后，对所有推广员的客户有以下影响：</p>
            <div class="influenceList">
                <p>1、如果在有效期内，则有效期自动更新为修改后的有效期；</p>
                <p>2、如果已解绑，不会有任何变化；</p>
                <p>不同的模式有什么区别？点击<span class="checkExplain">查看说明</span></p>
            </div>
            <el-input placeholder="请输入确认修改" v-model.trim="affirmEdit"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="clickAffirmEdit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'otherRulePop',
    data() {
        return {
            dialogVisible: false,
            affirmEdit: ''
        }
    },
    methods: {
        clickAffirmEdit() {
            if (this.affirmEdit !== '确认修改') {
                this.$message({
                    type: 'error',
                    message: '请输入确认修改'
                })
            } else {
                this.dialogVisible = false
                this.affirmEdit = ''
                this.$emit('affirm')
            }
        }
    }
}
</script>
<style lang="scss">
    .otherRulePop{
        .el-dialog{
            .influence{
                color: #F56C6C;
                font-size: 14px;
            }
            .influenceList{
                font-size: 14px;
                margin-top: 10px;
                line-height: 20px;
                .checkExplain{
                    color: #409EFF;
                    cursor: pointer;
                }
            }
            .el-input{
                margin-top: 20px;
            }
        }
    }
</style>